import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text"]

  connect() {
    this.phrases = [
      "beverage menu",
      "taproom display",
      "QR code menus",
      "full drink lineup",
      "digital menu board"
    ]

    this.currentIndex = 0
    this.startRotation()
  }

  disconnect() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval)
    }
  }

  startRotation() {
    this.rotationInterval = setInterval(() => {
      this.fadeOut()
    }, 3000)
  }

  fadeOut() {
    this.textTarget.style.transition = "opacity 0.3s ease-in-out"
    this.textTarget.style.opacity = "0"

    setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % this.phrases.length
      this.textTarget.textContent = this.phrases[this.currentIndex]
      this.fadeIn()
    }, 300)
  }

  fadeIn() {
    setTimeout(() => {
      this.textTarget.style.opacity = "1"
    }, 50)
  }
}
